// extracted by mini-css-extract-plugin
module.exports = {"screen-lg":"992px","screen-md":"768px","grid":"style_grid__R0osP","media":"style_media__bksIL"};